import { useIonViewDidLeave, useIonViewWillEnter, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";

// import Swiper core and required modules
import SwiperCore, { Virtual, Zoom, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/css/zoom";
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { showAlert, showConfirm } from '../components/Alert';
import NServer, { UIElement, handleRouteError } from "../components/NServer";
import Vault from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";
import { showTab, hideTab } from "../components/Tabs";
import './Main.css'; 

interface ImgViewerProp extends RouteComponentProps<{
    img : string,
    index : any,
    content : any,
    type : string
    }> 
{} 

var clicked = false;

const ImageViewer : React.FC<ImgViewerProp> = ({match}) => {

    const [swiperRef, setSwiperRef] = useState<any>(null);
    const [imageURL, setImageURL] = useState("/assets/img/avt.jpg");
    const [imageList, setImageList] = useState<string[]>([]);

    // need to refresh
    useEffect(() => {
        if (match.params.type == "content")
        {
            setImageURL(match.params.img);
            loadImageList();
        }
        else
        {
            // simply add current image to image list
            setImageList([decodeURIComponent(match.params.img)]);
        }
    },[match.params.img]);

    useIonViewDidLeave(() => {
        // showTab();
    });

    useIonViewWillEnter(() => {
        setImageURL(match.params.img);
        hideTab();
    });

    // load the image list
    const loadImageList = async () => {
        // upload the content
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: match.params.content,
            index : match.params.index,
            type : match.params.type
        }

        var server = new NServer();
        await server.getList("nc_image_list", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
        }
        else
        {
            setImageList(server.data);
        }
    }

    return (
        <IonPage>
            <IonContent>
                <IonToolbar className="toolbar-float">
                    <IonButtons slot="start">
                        <IonBackButton className="white-shadow" text="" defaultHref="/main" ></IonBackButton>
                    </IonButtons>
                </IonToolbar>
                {
                    imageList.length > 0 ?
                    ( match.params.index > 0 ?
                <Swiper
                    className="img-wrapper"
                    onSwiper={setSwiperRef}
                    slidesPerView={1}
                    initialSlide={match.params.index}
                    spaceBetween={0}
                    pagination={true}
                    modules={[Zoom, Pagination]}
                    zoom={true}
                    virtual
                >
                {
                    imageList.map( (m, index) => (
                    <SwiperSlide key={index} virtualIndex={index}>
                        <div className="swiper-zoom-container">
                            <img className="img-big"
                                src={ m } 
                                onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } }/>
                        </div>
                    </SwiperSlide>
                    ))
                }
                </Swiper>
                    :
                <Swiper
                    className="img-wrapper"
                    onSwiper={setSwiperRef}
                    slidesPerView={1}
                    spaceBetween={0}
                    pagination={true}
                    modules={[Zoom, Pagination]}
                    zoom={true}
                    virtual
                >
                {
                    imageList.map( (m, index) => (
                    <SwiperSlide key={index} virtualIndex={index}>
                        <div className="swiper-zoom-container">
                            <img className="img-big"
                                src={ m } 
                                onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } }/>
                        </div>
                    </SwiperSlide>
                    ))
                }
                </Swiper>
                )
                    :
                <div className="img-wrapper">
                    <img className="img-big"
                        src={ decodeURIComponent(imageURL) } 
                        onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } }/>
                </div>
                }
            </IonContent>
        </IonPage>
    );
};

export default ImageViewer;